// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1Qvlw","search":"Settings_search__HPpFK","filter":"Settings_filter__21Xq2"};